<--当前登录医生订单统计-->
<template>
    <div>
        <div style="padding:0 20px">
            <div class="top">
                <el-date-picker
                        v-model="date"
                        type="daterange"
                        align="right"
                        @change="dateChange"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions">
                </el-date-picker>
<!--                <el-select
                        size="small"
                        placeholder="诊所" style="width: 170px" v-model="query.hospitalNo" @change="getDate">
                    <el-option
                            v-for="item in hospitalList"
                            :key="item.hospitalNo"
                            :label="item.hospitalName"
                            :value="item.hospitalNo">
                    </el-option>
                </el-select>-->
            </div>
            <div class="then">
                <div class="then-in" style="margin-left: 12%">
                    <span>患者增加数</span>
                    <span class="then-in-number">{{chartData.patientCount}}</span>
                </div>
                <div class="then-in" style="margin-left: 12%">
                    <span>接诊数</span>
                    <span class="then-in-number">{{chartData.count}}</span>
                </div>
                <div class="line"></div>
                <div class="then-in" style="margin-right: 12%">
                    <span>接诊金额</span>
                    <span class="then-in-number" style="color:rgba(255,148,89,1);">{{chartData.totalAmt}}</span>
                </div>
                <div class="then-in" style="margin-right: 12%">
                    <span>药品金额</span>
                    <span class="then-in-number" style="color:rgba(255,148,89,1);">{{chartData.drugAmt}}</span>
                </div>
                <div class="then-in" style="margin-right: 12%">
                    <span>诊金</span>
                    <span class="then-in-number" style="color:rgba(255,148,89,1);">{{chartData.diagnoseAmt}}</span>
                </div>
            </div>
            <!--            <div class="chart-box">
                            <div id="count"></div>
                            <div id="totalAmt"></div>
                        </div>-->
            <el-table :data="list"
                      :header-cell-style="{'padding-left': '10%'}"
                      :cell-style="{'padding-left': '10%'}">
                <el-table-column prop="gmtCreated" label="日期"></el-table-column>
                <el-table-column prop="count" label="接诊数"></el-table-column>
                <el-table-column prop="totalAmt" label="订单金额"></el-table-column>
                <el-table-column prop="drugAmt" label="药品金额"></el-table-column>
                <el-table-column prop="diagnoseAmt" label="诊金"></el-table-column>


            </el-table>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page="query.pageNum"
                        :page-size="query.pageSize"
                        :total="total"
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>

        </div>
    </div>
</template>

<script>
    import {Chart} from '@antv/g2';
    import getDate from "../common/dataFormat";
    import revert from "../common/revert";
    export default {
        data() {
            return {
                list: [],
                authorization: localStorage.getItem('authorization'),
                date: '',
                pickerOptions: {
                    shortcuts: [{
                        text: '本周',
                        onClick(picker) {
                            const end = getDate.getCurrWeekDays().endtime;
                            const start = getDate.getCurrWeekDays().starttime;
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '上周',
                        onClick(picker) {
                            const end = getDate.getLastWeekDays().endtime;
                            const start = getDate.getLastWeekDays().starttime;
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '本月',
                        onClick(picker) {
                            const end = getDate.getCurrMonthDays().endtime;
                            const start = getDate.getCurrMonthDays().starttime;
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '上月',
                        onClick(picker) {
                            const end = getDate.getLastMonthDays().endtime;
                            const start = getDate.getLastMonthDays().starttime;
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                radioDate: '本周',
                handleDate: '',
                chartData: {
                    list:{
                        list:[]
                    }
                },
                // 分页信息
                pageNum: 1,
                pageSize: 10,
                total: 0,
                query: {
                    endTime: "",
                    startTime: "",
                    pageNum: 1,
                    pageSize: 10,

                }
            }
        },
        mounted() {

        },
        methods: {

            queryAgentDayOrderSum(agentNo) {
                this.dayVisible = true
                this.query.agentNo = agentNo;
                this.axios.post('/api-s/10009/100189', this.query, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        if (res.data.data.length>0) {
                            this.chartDayData = res.data.data
                            this.total = this.chartDayData.length
                            let start = this.pageSizeDay * (this.pageNumDay - 1)
                            let end = this.pageSizeDay * this.pageNumDay
                            this.listDay = []
                            for (let i = start; i < end; i++) {
                                if (i < end) {
                                    if (this.chartDayData[i]) {
                                        this.listDay.push(this.chartDayData[i])
                                    } else {
                                        break
                                    }
                                }
                            }

                        } else {
                            this.chartDayData = []
                        }

                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            getDate() {
                this.list=[]
                this.chartData = {}
                console.log(this.query)
                this.axios.post('/api-s/10009/100194', this.query, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    console.log(res)
                    if (res.data.code === 10000) {
                        if (res.data.data.list.list.length>0) {
                            this.chartData = res.data.data
                            this.total = this.chartData.list.total
                            this.query.pageNum = this.chartData.list.pageNum
                            this.query.pageSize = this.chartData.list.pageSize
                            this.list=this.chartData.list.list

                        } else {
                            this.chartData = {}
                        }

                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 表格换页
            handlePageChange(val) {
                this.query.pageNum = val;
                this.getDate()
            },
            dateChange(val) {
                this.query.startTime = val[0]
                this.query.endTime = val[1]
                this.getDate()
            }
        },
        created() {
            this.date = [
                getDate.getCurrWeekDays().starttime, getDate.getCurrWeekDays().endtime
            ]
            this.query.endTime = getDate.getCurrWeekDays().endtime;
            this.query.startTime = getDate.getCurrWeekDays().starttime;
            this.getDate()
        }
    }

</script>
<style>

</style>
<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        margin-top: 13px;
        height: 52px;
    }

    .then {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        height: 112px;
        background: rgba(251, 254, 255, 1);
        border-radius: 4px;
        border: 1px solid rgba(210, 237, 255, 1);
        margin-bottom: 20px;
    }

    .then-in {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        height: 70px;
        color: rgba(102, 102, 102, 1);
        font-size: 14px;
    }

    .then-in-number {
        font-size: 30px;
        font-weight: bold;
        color: rgba(97, 167, 255, 1);
    }

    .line {
        width: 1px;
        height: 112px;
        background: rgba(210, 237, 255, 1);
    }

    .chart-box {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        padding: 30px 0;
        width: 100%;
        height: 423px;
        background: rgba(251, 254, 255, 1);
        border-radius: 8px;
        border: 1px solid rgba(210, 237, 255, 1);
        margin-bottom: 20px;
    }
</style>